<template>
  <div class="fireManage"
       v-loading.fullscreen.lock="loadingCB"
       :element-loading-text="loadingCText"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-container>
      <!-- <el-scrollbar style="margin-bottom:15x;width:700px"> -->
      <el-aside v-loading="loadingC"
                :element-loading-text="loadingCText"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)">
        <div v-if="showPassWord">
          <div class="password">
          </div>
          <div>
            <div class="elbut">
              <el-form :model="ruleForm"
                       status-icon
                       @submit.native.prevent
                       :rules="rules"
                       ref="ruleForm">
                <el-form-item prop="password">
                  <el-input placeholder="请输入密码"
                            :disabled="detail.deviceId?false:true"
                            v-model="ruleForm.password"
                            @keyup.native.enter="untie"
                            show-password>
                    <el-button @click="untie"
                               slot="append"
                               :disabled="detail.deviceId?false:true"
                               :loading="passwordLoading"
                               icon="el-icon-thumb"
                               type="primary">
                      {{passwordLoading?"解锁中":"解锁"}}
                    </el-button>
                  </el-input>
                </el-form-item>
              </el-form>
              <div style="color:red">
                *请输入密码解锁键盘
              </div>
            </div>
          </div>

        </div>
        <!-- 设备 -->
        <div style="position: absolute;right: 0;top: 5px">
          <el-button type="primary"
                     style="padding:5px 10px"
                     v-if="!switchFj"
                     :disabled="!handleType"
                     @click="handleType=false"
                     icon="el-icon-s-help">一键操作</el-button>
          <el-button type="primary"
                     @click="handleType=true"
                     style="padding:5px 10px"
                     :disabled="handleType"
                     icon="el-icon-thumb">单键操作</el-button>
        </div>
        <div class="leftTop"
             v-if="handleType">
          <!-- 物联网 -->
          <fireIndex2 v-if="controlType==2"
                      ref="controlDevice"
                      @controlCallBack="controlCallBack">
            {{selectDeviceData.relationDeviceName || detail.deviceName}}
          </fireIndex2>
          <!-- new 键盘 -->
          <fireIndexGst v-if="controlType=='GST500' || controlType=='GST5000' || controlType=='GST1500H'"
                        ref="controlDevice"
                        :deviceVersion="!detail.subDeviceMark? detail.deviceVersion : detail.parentDeviceVersion"
                        :deviceName="detail.subDeviceMark? detail.parentThirdDeviceName : detail.deviceName"
                        :fireType="$route.query.alarmType"
                        @controlCallBack="controlCallBack" />
          <fireIndexGstT v-if="controlType=='GST200'"
                         ref="controlDevice"
                         :deviceVersion="!detail.subDeviceMark? detail.deviceVersion : detail.parentDeviceVersion"
                         :deviceName="detail.subDeviceMark? detail.parentThirdDeviceName : detail.deviceName"
                         :fireType="$route.query.alarmType"
                         @controlCallBack="controlCallBack" />
          <fireIndexGstTS v-if="controlType=='GST200-2'"
                          ref="controlDevice"
                          :deviceVersion="!detail.subDeviceMark? detail.deviceVersion : detail.parentDeviceVersion"
                          :deviceName="detail.subDeviceMark? detail.parentThirdDeviceName : detail.deviceName"
                          :fireType="$route.query.alarmType"
                          @controlCallBack="controlCallBack" />
          <fireIndexGstH v-if="controlType=='GST15000H'"
                         ref="controlDevice"
                         :deviceVersion="!detail.subDeviceMark? detail.deviceVersion : detail.parentDeviceVersion"
                         :deviceName="detail.subDeviceMark? detail.parentThirdDeviceName : detail.deviceName"
                         :fireType="$route.query.alarmType"
                         @controlCallBack="controlCallBack" />
          <fireIndexJbf v-if="controlType=='JBF-11SF-H' || controlType=='JBF-11SF' || controlType=='JBF-11SF-S'"
                        ref="controlDevice"
                        :deviceVersion="!detail.subDeviceMark? detail.deviceVersion : detail.parentDeviceVersion"
                        :deviceName="detail.subDeviceMark? detail.parentThirdDeviceName : detail.deviceName"
                        :fireType="$route.query.alarmType"
                        @controlCallBack="controlCallBack" />
        </div>
        <div v-else
             class="leftTop">
          <!-- 一键操作 -->
          <div class="handlePage">
            <el-scrollbar style="margin-bottom:15x">
              <div class="handletab">
                <div v-for="(item,index) in handleList"
                     :class="['handTabItem',activeName==index?'activeItem':'']"
                     :title="item.operationConfigTypeName"
                     @click="handleClickTab(index)"
                     :key="item.operationConfigTypeCode">
                  <span>{{item.operationConfigTypeName}}</span>
                  <span class="icon">
                    <i class="el-icon-edit"
                       title="编辑"
                       @click.stop="handleTabsEdit(index,'edit')"></i>
                    <i class="el-icon-close"
                       title="删除"
                       @click.stop="handleTabsEdit(index,'remove')"></i>
                  </span>
                </div>

              </div>
            </el-scrollbar>
            <el-button type="primary"
                       style="position: absolute;top: 85px;right: 10px;z-index:2"
                       @click="handleTabsEdit('','add')"
                       icon="el-icon-plus"
                       circle></el-button>
            <el-scrollbar>
              <el-steps :active="activeStep"
                        class="handStep"
                        finish-status="success"
                        align-center>
                <el-step :title="'按键：'+itemitem.inputContent"
                         v-for="itemitem in handleItem"
                         :key="itemitem.sortNo"
                         :description="itemitem.stepName">
                  <template slot="description">
                    <div class="el-step__description">
                      {{itemitem.stepName}}
                    </div>
                    <div class="step-row">
                      <i class="el-icon-edit"
                         title="编辑步骤"
                         @click="editStep(itemitem)"></i>
                      <i class="el-icon-delete"
                         title="删除步骤"
                         @click="deleteStep(itemitem)"></i>
                    </div>
                  </template>
                </el-step>
              </el-steps>
            </el-scrollbar>

            <div>
              <el-button type="primary"
                         style="padding:5px 10px;margin-right:10px"
                         @click="addStep"
                         icon="el-icon-plus">新增步骤</el-button>
              <span v-if="handleItem.length">
                <el-button type="primary"
                           v-if="!isAction"
                           style="padding:5px 10px"
                           @click="actionStep"
                           icon="el-icon-s-help">开始操作</el-button>
                <el-button type="primary"
                           v-if="isAction && activeStep!=handleItem.length"
                           @click="handleStep"
                           style="padding:5px 10px">下一步</el-button>
                <el-button type="primary"
                           v-if="isAction && activeStep==handleItem.length"
                           @click="handleType=true"
                           style="padding:5px 10px">完成</el-button>
                <el-button type="primary"
                           @click="handleType=true"
                           style="padding:5px 10px">取消</el-button>
              </span>
            </div>
          </div>
        </div>
        <!-- 单建模式下关联风机水泵 -->
        <div class="pagefjDevice">
          <div style="display: flex;
    justify-content: space-between;">
            关联风机数据：
            <div>
              <el-button type="primary"
                         style="padding:5px 15px"
                         v-if="switchFj"
                         @click="handleBack"
                         icon="iconfont icon-iconfontfanhui">返回</el-button>
              <el-button type="primary"
                         style="padding:5px 15px"
                         @click="handleAdd"
                         icon="el-icon-plus"></el-button>

            </div>
          </div>
          <div class="tabsDevice">
            <el-tabs v-model="activeDevice"
                     class="tabs"
                     @tab-click="handleClickDevice">
              <el-tab-pane v-for="(item,index) in deviceFjList"
                           :key="index"
                           :label="item.relationDeviceName"
                           :name="index.toString()">
                <div slot="label"
                     style="position:relative">
                  <div class="tabs_content"
                       :title="item.relationDeviceName">
                    <i :title="item.relationDeviceName"
                       class="icon iconfont-lunan"
                       :class="['icon-lunan-SENU087' + (item.relationDeviceType || 28)]"></i>
                    <div class="tabs_content_title">
                      {{item.relationDeviceName.slice(0,6)}}
                    </div>
                    <div class="tabs_content_title">
                      {{item.relationDeviceName.slice(6,item.relationDeviceName.length)}}
                    </div>

                  </div>
                  <span class="iconClose">
                    <i class="el-icon-close"
                       title="解除关联"
                       @click.stop="handleDeviceEdit(index,'remove')"></i>
                  </span>
                </div>
              </el-tab-pane>
            </el-tabs>

          </div>
        </div>
        <!-- 设备信息 -->
        <div class="leftButton"
             v-if="detail.deviceId">
          <div class="footer">
            <div style="text-align:left;font-size:16px;margin-bottom:10px">
              设备信息：
            </div>
            <div class="deviceInfo">
              <div>
                <span>
                  消防主机名称：
                </span>
                <span>
                  {{ detail.subDeviceMark? detail.parentThirdDeviceName :detail.deviceName}}
                </span>
              </div>
              <div>
                <span>
                  唯一设备标识：
                </span>
                <span>
                  {{detail.thirdDeviceId}}
                </span>
              </div>
              <div>
                <span>
                  设备型号：
                </span>
                <span>
                  {{(detail.subDeviceMark?detail.parentDeviceVersion : detail.deviceVersion) | dic("SENU095") }}
                </span>
              </div>
              <div>
                <span>
                  IP地址：
                </span>
                <span>
                  {{detail.subDeviceMark? detail.parentIp : detail.ip}}
                </span>
              </div>
              <div>
                <span>
                  厂商：
                </span>
                <span>
                  {{detail.subDeviceMark? detail.parentFactoryName:detail.factoryName }}
                </span>
              </div>
              <div v-if="detail.subDeviceMark">
                <span>
                  部件名称：
                </span>
                <span>
                  {{ detail.deviceName }}
                </span>
              </div>
              <div v-if="detail.subDeviceMark">
                <span>
                  部件编号：
                </span>
                <span>
                  {{ detail.mac}}
                </span>
              </div>
              <div v-if="detail.subDeviceMark">
                <span>
                  部件型号：
                </span>
                <span>
                  {{ detail.subDeviceMark | dic("SENU094") }}
                </span>
              </div>
              <!-- <div v-if="detail.subDeviceMark">
                <span>
                  部件状态：
                </span>
                <span>
                  正常
                </span>
              </div> -->
              <div v-if="detail.subDeviceMark">
                <span>
                  回路：
                </span>
                <span>
                  {{ detail.loop }}
                </span>
              </div>
            </div>
          </div>
          <div class="footerButton"
               v-if="alarmFire.length"
               style="margin:10px">
            <el-button type="primary"
                       @click="goBackT">确认处理</el-button>
            <!-- <el-button @click="goBackT">取消</el-button> -->
          </div>
        </div>
        <div class="no-data-text"
             v-else>
          <div>
            <img src="@/common/assets/images/empty.svg"
                 class="no-data_img" />
          </div>
          <div>
            暂无数据
          </div>
        </div>
      </el-aside>
      <!-- </el-scrollbar> -->

      <el-main>
        <div style="text-align:end;margin-bottom:10px;margin-top:-4px">
          <el-button type="primary"
                     @click="addCamera"
                     style="padding:5px 10px"
                     icon="iconfont icon-xinzeng">添加摄像机</el-button>
          <el-button type="primary"
                     @click="goBack"
                     style="padding:5px 10px"
                     icon="iconfont icon-iconfontfanhui">返回上一页</el-button>
        </div>
        <VideojsPlayerNew ref="player"
                          style="height:calc( 100% - 55px);color:#fff"
                          :windowNumber="windowNumber"></VideojsPlayerNew>
        <div class="wnNum">
          <div>
            <el-button class="iconfont-lunan icon-lunan-tingzhi"
                       type="text"
                       style="margin-top:-5px"
                       size="medium"
                       title="关闭所有窗口"
                       @click.stop="stopAll"
                       onselectstart="return false;"></el-button>
          </div>
          <el-popover placement="top"
                      width="50"
                      style="margin-top:5px;"
                      trigger="click">
            <div style="display: flex;flex-wrap: wrap;justify-content: space-evenly;">
              <span class="iconfont"
                    title="一分屏"
                    style="cursor: pointer;"
                    @click.stop="changeWindowNumber(1)">&#xe648;</span>
              <span class="iconfont"
                    title="四分屏"
                    style="cursor: pointer;"
                    @click.stop="changeWindowNumber(4)">&#xe645;</span>
              <span class="iconfont"
                    title="九分屏"
                    style="cursor: pointer;"
                    @click.stop="changeWindowNumber(9)">&#xe70e;</span>
            </div>
            <div class="iconfont"
                 slot="reference"
                 style="cursor: pointer;"
                 :title="$t('video.title.fourScreen')">
              &#xe645;&#xe623;
            </div>
          </el-popover>
        </div>
      </el-main>
    </el-container>
    <!-- 摄像机弹窗 -->
    <el-dialog title="摄像机列表"
               :visible.sync="dialogVisible"
               width="400px"
               v-dialogDrag
               :before-close="handleClose">
      <el-scrollbar style="height:400px">
        <area-device-tree ref="deviceTree"
                          @cameraData="cameraData"
                          :multiCheck="true"></area-device-tree>
      </el-scrollbar>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary"
                   @click="submitDialog">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 键盘弹窗 -->
    <el-dialog title="提示"
               :visible.sync="dialogDevice"
               v-dialogDrag
               width="350px">
      <span>是否执行键盘【{{ deviceKey | dic("SENU098") }} 】操作？ </span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogDevice=false">取 消</el-button>
        <el-button type="primary"
                   @click="sendControl">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 水喷雾灭火系统及防烟排烟系统控制器编号弹窗 -->
    <el-dialog title="选择控制器编号"
               :visible.sync="dialogControl"
               v-dialogDrag
               width="350px">
      <el-form :model="controlForm"
               ref="controlForm"
               :rules="controlRules">
        <el-form-item label="控制器编号"
                      prop="controlCode">
          <el-select v-model="controlForm.controlCode"
                     @change="controlCodeChange"
                     style="width: 100%"
                     placeholder="请选择控制器编号">
            <el-option v-for="item in controlCodeOption"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogControl=false">取 消</el-button>
        <el-button type="primary"
                   @click="sendControlCode">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 键盘输入 -->
    <el-dialog title="键盘输入"
               v-ops:width="680"
               v-dialogDrag
               :visible.sync="dialogShow"
               @close="dialogShow=false"
               :close-on-click-modal="false">
      <el-scrollbar style="height:540px">
        <!-- 物联网 -->
        <fireIndex2 v-if="controlType==2"
                    ref="controlDevice"
                    @controlCallBack="controlCallBack" />
        <!-- new 键盘 -->
        <fireIndexGst v-if="controlType=='GST500' || controlType=='GST5000' || controlType=='GST1500H'"
                      ref="controlDevice"
                      :deviceVersion="!detail.subDeviceMark? detail.deviceVersion : detail.parentDeviceVersion"
                      :deviceName="detail.subDeviceMark? detail.parentThirdDeviceName : detail.deviceName"
                      :fireType="$route.query.alarmType"
                      @controlCallBack="controlCallBack" />
        <fireIndexGstT v-if="controlType=='GST200'"
                       ref="controlDevice"
                       :deviceVersion="!detail.subDeviceMark? detail.deviceVersion : detail.parentDeviceVersion"
                       :deviceName="detail.subDeviceMark? detail.parentThirdDeviceName : detail.deviceName"
                       :fireType="$route.query.alarmType"
                       @controlCallBack="controlCallBack" />
        <fireIndexGstH v-if="controlType=='GST15000H'"
                       ref="controlDevice"
                       :deviceVersion="!detail.subDeviceMark? detail.deviceVersion : detail.parentDeviceVersion"
                       :deviceName="detail.subDeviceMark? detail.parentThirdDeviceName : detail.deviceName"
                       :fireType="$route.query.alarmType"
                       @controlCallBack="controlCallBack" />
        <fireIndexGstTS v-if="controlType=='GST200-2'"
                        ref="controlDevice"
                        :deviceVersion="!detail.subDeviceMark? detail.deviceVersion : detail.parentDeviceVersion"
                        :deviceName="detail.subDeviceMark? detail.parentThirdDeviceName : detail.deviceName"
                        :fireType="$route.query.alarmType"
                        @controlCallBack="controlCallBack" />
        <fireIndexJbf v-if="controlType=='JBF-11SF-H' || controlType=='JBF-11SF' || controlType=='JBF-11SF-S'"
                      ref="controlDevice"
                      :deviceVersion="!detail.subDeviceMark? detail.deviceVersion : detail.parentDeviceVersion"
                      :deviceName="detail.subDeviceMark? detail.parentThirdDeviceName : detail.deviceName"
                      :fireType="$route.query.alarmType"
                      @controlCallBack="controlCallBack" />
      </el-scrollbar>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="overDialog">结 束</el-button>
        <el-button @click="dialogShow=false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 新增类型弹窗 -->
    <el-dialog :title="dialogTitle"
               v-dialogDrag
               width="400px"
               class="choose-box"
               :before-close="cancleForm"
               :visible.sync="dialogConfigType">
      <el-form :model="configForm"
               :rules="rules"
               ref="configForm"
               label-width="100px">
        <el-form-item label="类型名称"
                      prop="name"
                      label-width="80px">
          <el-input v-model="configForm.name"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancleForm">取消</el-button>
        <el-button type="primary"
                   @click="confirmForm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 消防设备弹窗 -->
    <el-dialog title="选择设备"
               width="1020px"
               :before-close="cancleFireDevice"
               :visible.sync="dialogFireDevice"
               v-dialogDrag>
      <ioc-table ref="multipleTable"
                 :data="tableDataDevice"
                 :option="deviceOptions"
                 :page="devicePage"
                 @size-change="personChangeSize"
                 @search-reset="handleSearchReset"
                 @search-change="handleSearchChange"
                 @selection-change="handeleSelect"
                 @current-change="currentChange">
      </ioc-table>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancleFireDevice">取消</el-button>
        <el-button type="primary"
                   @click="confirmFireDevice">确认</el-button>
      </span>
    </el-dialog>
    <!-- 新增/修改键盘内容 -->
    <add-config-dialog ref="addDialog"
                       :state="state"
                       :controlType="controlType"
                       :deviceId="switchFj ? selectDeviceData.relationDeviceId:hostId"
                       :detail="detail"
                       :stepInfo="stepInfo"
                       @refresh="getFireActionList(type.operationConfigTypeCode)"></add-config-dialog>
  </div>
</template>
<script>
import sha256 from 'js-sha256'
import { Dic } from '$utils'
import { api } from "../api";
import utils from "@src/common/utils";
import areaDeviceTree from "@src/modules/video/components/realTime/device-group-tree";
import VideojsPlayerNew from '@src/components/common/media-player/video-playerNew.vue'
import fireIndex from "../components/fireTemplate/index";
import fireIndex2 from "../components/fireTemplate/index2";//物联网
import fireIndexGst from "../components/fireTemplate/GTS500";//Gst500
import fireIndexGstS from "../components/fireTemplate/GTS500";//Gst5000
import fireIndexGstT from "../components/fireTemplate/GTS200-1";//Gst200
import fireIndexGstTS from "../components/fireTemplate/GTS200-2";//Gst200-2
import fireIndexGstH from "../components/fireTemplate/GTS15000H";//Gst15000H
import fireIndexJbf from "../components/fireTemplate/new1";//JBF11FS
import fireIndexJbfS from "../components/fireTemplate/new1";//JBF11FS-1
import { deviceOptions } from "../const/operation";
import addConfigDialog from "@src/modules/cameraList/components/addConfigDialog";
export default {
  watch: {
    handleType (val) {
      // false是单建操作，true是一键操作
      if (val == false) {
        // this.getConfigTypeList()
        this.activeName = "0"
        this.handleList.length && this.getFireActionList(this.handleList[0].operationConfigTypeCode)
      }
      this.activeStep = null
      this.isAction = false
    },
  },
  components: {
    areaDeviceTree,
    VideojsPlayerNew,
    fireIndex2,
    // new 键盘
    fireIndexGst,
    fireIndexGstT,
    fireIndexGstTS,
    fireIndexGstH,
    fireIndexJbf,
    addConfigDialog
  },
  data () {
    return {
      switchFj: false,
      deviceFjList: [],
      activeDevice: "-1",
      devicePage: {
        pageNum: 1,
        total: 0,
        alarmType: [],
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      deviceOptions: deviceOptions(),
      tableDataDevice: [],
      selectDevice: [],
      dialogFireDevice: false,
      dialogTitle: "新增类型",
      configForm: {
        name: "",
        code: ""
      },
      type: {},
      dialogConfigType: false,
      dialogShow: false,
      operationKeyType: "",//1.键盘输入，2固定输入
      isAction: false,
      // handleList: Dic.find('SENU099'),
      handleList: [],
      handleItem: [],
      activeName: '',
      activeStep: null,
      handleType: false,
      deviceVersion: '',
      deviceName: '',
      fireType: "",
      dialogDevice: false,
      deviceKey: '',
      passwordLoading: false,
      isOpen: false,
      loadingC: false,
      loadingCB: false,
      loadingCText: "加载中",
      detail: {},
      rules: {
        password: [
          { required: true, message: '密码不正确,请重新输入', trigger: ['change', "blur"], }
        ],
        name: [
          { required: true, message: '请输入类型名称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ]
      },
      ruleForm: {
        password: ""
      },
      controlType: "",//海湾CGS200  GTS200-1   GTS500 GTS500-1 2.物联网  北大JBF11FS-1  JBF11FS-2
      screenSet: false,
      showPassWord: true,
      windowNumber: 4,
      dialogVisible: false,
      isGetResult: false,
      camera: [],
      orderList: [],//一键操作指令list
      orderIndex: -1,
      timeData: null,
      alarmFire: [],
      selectDeviceData: {},
      dialogControl: false,
      state: 1, // 1: 新增 2：修改
      controlForm: {
        controlCode: '',
      },
      stepInfo: {},
      hostId: "",//主机id
      controlCodeOption: Dic.find('SENU095001'),
      controlRules: {
        controlCode: [{ required: true, message: "请选择控制器编号", trigger: "change" }]
      },
      backType: "2",
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      sessionStorage.setItem("fireAfter", JSON.stringify({
        routeCopy: from.path,
        nameCopy: from.name
      }));
    })
  },
  created () {
    this.alarmFire = (this.$route.query.alarmFire && this.$route.query.alarmFire.split('-')) || []
    this.getDeviceDetail(this.$route.query.id)
    this.getDeviceVideo(this.$route.query.id)
  },
  mounted () {
    // this.getConfigTypeList()
    this.getFireDeviceList()
  },
  // 本页面代码有点紊乱 后期应重新封装--待定
  methods: {
    addStep () {
      this.stepInfo = {};
      this.state = 1;
      this.$refs.addDialog.open(this.type.operationConfigTypeCode);
    },
    // 修改步骤内容
    editStep (data) {
      this.stepInfo = data;
      this.state = 2;
      this.$nextTick(() => {
        this.$refs.addDialog.open(this.type.operationConfigTypeCode);
      });
    },

    // 删除步骤
    deleteStep (data) {
      let params = {
        operationConfigCode: data.operationConfigCode,
      };
      this.$confirm("确定对步骤【" + data.stepName + "】执行删除操作？", "操作确认", {
        type: "warning",
      }).then((res) => {
        this.$fetch(api.deleteConfigStep, params).then((res) => {
          if (res.success) {
            this.getFireActionList(this.type.operationConfigTypeCode)
            this.$message.success(res.msgContent || "删除成功 ");
          } else {
            this.$message.error(res.msgContent || "删除失败");
          }
        })

      })
        .catch((e) => {
        })
    },
    handleSearchReset () {
      this.devicePage.parentDeviceName = '';
      this.devicePage.pageNum = 1
      this.devicePage.pageSize = 10
      this.getFireDeviceList();
    },
    handleSearchChange (param) {
      this.devicePage.parentDeviceName = param.parentDeviceName;
      this.getFireDeviceList();
    },
    personChangeSize (val) {
      this.devicePage.pageNum = 1;
      this.devicePage.pageSize = val;
      this.getFireDeviceList();
    },
    // 风机水泵选中回调
    handeleSelect (data) {
      this.selectDevice = [...data]

    },
    currentChange (val) {
      this.devicePage.pageNum = val;
      this.getFireDeviceList();
    },
    cancleFireDevice () {
      this.selectDevice = []
      this.dialogFireDevice = false
    },
    // 关联风机水泵确认回调
    confirmFireDevice () {
      this.dialogFireDevice = false
      // this.deviceFjList = [...this.selectDevice]
      this.$fetch(api.addDeviceRelationDevice, {
        deviceId: this.$route.query.id,
        relationDeviceIdList: this.selectDevice.map(el => {
          return el.deviceId
        }),
      }).then((res) => {
        if (res.success) {
          this.selectDevice.map(item => {
            this.deviceFjList.push({
              deviceId: this.$route.query.id,
              relationDeviceId: item.deviceId,
              relationDeviceName: item.parentDeviceName,
            })
          })
          // this.activeDevice = Number(this.deviceFjList.length - 1).toString()
          this.$message.success(res.msgContent || "关联成功 ");
        } else {
          this.$message.error(res.msgContent || "关联失败");
        }
      })
    },
    // 切换为主机键盘
    handleBack () {
      if (this.backType == 2) {
        // 返回到一键操作
        this.handleType = true
      } else {
        this.handleType = false
      }
      this.switchPageType(this.$route.query.id)
      this.activeDevice = "-1"
      this.switchFj = false
      this.getConfigTypeList(true)
    },
    // 关联风机水泵
    handleAdd () {
      this.dialogFireDevice = true
      // 选中回显
      this.$nextTick(() => {
        this.$refs.multipleTable.$refs.multipleTable.clearSelection();
      })
    },
    // 新增/编辑类型
    confirmForm () {
      this.$refs.configForm.validate((valid) => {
        if (valid) {
          let params = {
            deviceId: this.switchFj ? this.selectDeviceData.relationDeviceId
              : this.hostId,
            operationConfigTypeName: this.configForm.name
          };
          let url = api.addConfigTypeList
          if (this.dialogTitle == '编辑类型') {
            params.operationConfigTypeCode = this.configForm.code
            url = api.updateConfigTypeList
          }
          this.$fetch(url, params).then((res) => {
            if (res && res.success) {
              this.getConfigTypeList()
              this.$message.success(res.msgContent || "操作成功");
              this.$refs.configForm.resetFields();
              this.dialogConfigType = false
            } else {
              this.$message.error(res.msgContent || "操作失败");
            }
          });
        }
      })
    },
    cancleForm () {
      this.$refs.configForm.resetFields();
      this.dialogConfigType = false
    },
    // 切换键盘专用
    switchPageType (deviceId) {
      this.$fetch(api.fire.getDeviceDetail, { deviceId: deviceId }).then((res) => {
        if (res.success) {
          let detail = res.returnObj.deviceInfo
          if (detail.deviceType == "27") {
            if (detail.subDeviceMark) {
              if (detail.parentFactoryId == 1) {
                this.controlType = Dic.findByValue('SENU095', this.detail.parentDeviceVersion)
              } else {
                // 默认显示海湾
                this.controlType = Dic.findByValue('SENU095', this.detail.parentDeviceVersion)
                // this.controlType = 1
              }
            } else {
              // 主机
              if (detail.factoryId == 1) {
                // this.controlType = 5
                this.controlType = Dic.findByValue('SENU095', this.detail.deviceVersion)
              } else {
                this.controlType = Dic.findByValue('SENU095', this.detail.deviceVersion)
                // this.controlType = 1
              }
            }
          } else {
            this.controlType = '2'
          }
        } else {
          this.$message.error(res.msgContent || "查询数据失败");
        }
      })
    },
    // 点击风机水泵
    handleClickDevice (val) {
      this.switchFj = true;
      this.selectDeviceData = this.deviceFjList[Number(val.index)];
      this.switchPageType(this.selectDeviceData.relationDeviceId);
      this.getConfigTypeList(true);
      this.$nextTick(() => {
        if (this.handleType == false) {
          // 切换为单键模式
          this.handleType = true
          this.backType = 1
        } else {
          this.backType = 2
        }
      })
    },
    handleDeviceEdit (targetName, action) {
      if (action === 'remove') {
        this.$confirm("确定对风机【" + this.deviceFjList[targetName].relationDeviceName + "】解除关联？", "操作确认", {
          type: "warning",
        }).then((res) => {
          this.$fetch(api.deleteDeviceRelationDevice, {
            deviceId: this.$route.query.id,
            relationDeviceId: this.deviceFjList[targetName].relationDeviceId,
          }).then((res) => {
            if (res.success) {
              this.deviceFjList.splice(targetName, 1)
              if (this.activeDevice == targetName) {
                this.activeDevice = targetName - 1 == -1 ? "0" : (targetName - 1).toString();
              }
              // this.getConfigTypeList()
              this.$message.success(res.msgContent || "解除关联成功 ");
            } else {
              this.$message.error(res.msgContent || "解除关联失败");
            }
          })

        })
          .catch((e) => {
          })
      }
    },
    handleTabsEdit (targetName, action) {
      // 新增操作
      if (action === 'add') {
        this.dialogTitle = "新增类型"
        this.dialogConfigType = true
      }
      // 编辑操作
      if (action === 'edit') {
        this.dialogTitle = "编辑类型"
        this.dialogConfigType = true
        this.configForm.name = this.handleList[targetName].operationConfigTypeName
        this.configForm.code = this.handleList[targetName].operationConfigTypeCode
      }
      // 删除操作
      if (action === 'remove') {
        this.$confirm("确定对类型【" + this.handleList[targetName].operationConfigTypeName + "】执行删除操作？", "操作确认", {
          type: "warning",
        }).then((res) => {
          this.$fetch(api.deleteConfigTypeList, {
            deviceId: this.switchFj ? this.selectDeviceData.relationDeviceId
              : this.hostId,
            operationConfigTypeCode: this.handleList[targetName].operationConfigTypeCode,
          }).then((res) => {
            if (res.success) {
              this.activeName = targetName - 1 == -1 ? "0" : (targetName - 1).toString();
              this.getConfigTypeList()
              this.$message.success(res.msgContent || "删除成功 ");
            } else {
              this.$message.error(res.msgContent || "删除失败");
            }
          })

        })
          .catch((e) => {
          })
      }
    },
    // 获取模块类型配置
    getConfigTypeList (isFirst = false) {
      let params = {
        deviceId: this.switchFj ? this.selectDeviceData.relationDeviceId
          : this.hostId,
      };
      this.$fetch(api.queryConfigTypeList, params).then((res) => {
        if (res && res.success) {
          this.handleList = res.returnObj;
          this.type = res.returnObj[0];
          if (isFirst) {
            this.activeName = "0"
            this.handleList.length && this.getFireActionList(this.handleList[0].operationConfigTypeCode)
          }
        } else {
          this.$message.error(res.msgContent || "获取数据失败");
        }
      });
    },
    // 获取消防设备
    getFireDeviceList () {
      let params = {
        pageNum: this.devicePage.pageNum,
        pageSize: this.devicePage.pageSize,
        deviceId: this.$route.query.id,
        deviceMarkList: ["28", "29"],
        parentDeviceName: this.devicePage.parentDeviceName,
        systemId: 200000024
      };
      this.$fetch(api.fire.queryFireDeviceList, params).then((res) => {
        if (res && res.success) {
          this.tableDataDevice = res.returnObj.list;
          this.devicePage.total = res.returnObj
            ? res.returnObj.total
            : 0;
        } else {
          this.$message.error(res.msgContent || "获取数据失败");
        }
      });
    },
    // 结束键盘输入并进入下一步
    overDialog () {
      this.dialogShow = false
      this.activeStep += 1
    },
    getFireActionList (type) {
      let parsms = {
        deviceId: this.switchFj ? this.selectDeviceData.relationDeviceId
          : this.hostId,
        operationConfigType: type
      }
      this.$fetch(api.fire.queryFireFightingOperationConfigList, parsms).then((res) => {
        // 步骤详情
        if (res && res.success) {
          // this.activeName = type.toString()
          this.handleItem = []
          if (res.returnObj.length) {
            let data = res.returnObj
            this.handleItem = [].concat([...data])
          }
        } else {
          res.msgContent && this.$message.error(res.msgContent);
        }
      })
    },
    // 一键操作开始
    actionStep () {
      this.isAction = true
      this.activeStep = 0
    },
    // 发送指令
    sendStep () {
      this.isGetResult = false
      let params = {
        deviceId: this.switchFj ? this.selectDeviceData.relationDeviceId : this.$route.query.id,
        cmdKey: this.orderList[this.orderIndex],
        needUnLockFlag: this.switchFj ? 0 : 1,
        operateType: this.handleType ? 1 : 2,//1：单键操作，2：一键操作
      }
      this.$fetch(api.fire.controlFirefighting, params).then((res) => {
        if (res && res.success) {
          this.timeData = setTimeout(() => {
            if (!this.isGetResult) {
              this.isGetResult = true
              this.$alert('按钮响应超时,请进行复位操作 !', '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                showClose: false,
                callback: action => {
                  this.loadingC = false
                }
              });
            }
          }, 10000)
          this.getResult(res.returnObj)
        } else {
          res.msgContent && this.$message.error(res.msgContent);
          this.orderIndex = -1
          this.loadingC = false
        }
      })

    },
    // 下一步按钮
    handleStep () {
      // 发送指令 operationKeyType 
      let stepData = this.handleItem[this.activeStep]
      this.operationKeyType = stepData.operationKeyType
      this.orderIndex = 0
      // console.log(this.operationKeyType)
      if (stepData.operationKeyType == 1) {
        // 键盘输入 弹出键盘
        this.dialogShow = true
      } else {
        this.orderList = stepData.inputContent.split(';')
        this.sendStep()
        this.loadingCText = "等待操作响应"
        this.loadingC = true
      }

    },
    // 展示节点下的步骤详情
    handleClickTab (val) {
      this.activeName = val
      this.type = this.handleList[Number(val)];
      this.getFireActionList(this.type.operationConfigTypeCode)
    },
    getDeviceDetail (data) {
      this.loadingCText = "加载中"
      this.loadingC = true
      this.$fetch(api.fire.getDeviceDetail, { deviceId: data }).then((res) => {
        setTimeout(() => {
          this.loadingC = false
        }, 1000);
        if (res && res.success) {
          let detail = res.returnObj.deviceInfo
          if (!detail) {
            this.$message.error("暂无设备信息")
            return
          }
          this.detail = res.returnObj.deviceInfo;
          this.hostId = this.detail.subDeviceMark ? this.detail.parentDeviceId : this.detail.deviceId
          this.getConfigTypeList()
          this.deviceFjList = res.returnObj.deviceInfo.deviceRelationDeviceList || []
          if (this.detail.deviceType == "27") {
            // controlType 海湾CGS200  GTS200-1   GTS500 GTS500-1 2.物联网  北大JBF11FS-1  JBF11FS-2
            // FactoryId 1北大  2海湾 -1未知
            if (this.detail.subDeviceMark) {
              // Dic.findByValue('SENU095', res.returnObj)
              // 部件parentDeviceVersion/deviceVersion
              if (this.detail.parentFactoryId == 1) {
                this.controlType = Dic.findByValue('SENU095', this.detail.parentDeviceVersion)
              } else {
                // 默认显示海湾
                this.controlType = Dic.findByValue('SENU095', this.detail.parentDeviceVersion)
                // this.controlType = 1
              }
            } else {
              // 主机
              if (this.detail.factoryId == 1) {
                // this.controlType = 5
                this.controlType = Dic.findByValue('SENU095', this.detail.deviceVersion)
              } else {
                this.controlType = Dic.findByValue('SENU095', this.detail.deviceVersion)
                // this.controlType = 1
              }
            }
          } else {
            let arr = [];
            if (this.detail.controlCodeList) {
              this.controlCodeOption.forEach((item) => {
                this.detail.controlCodeList.forEach((items) => {
                  if (item.value == items) {
                    arr.push(item)
                  }
                })
              })
            }
            this.controlCodeOption = arr
            this.controlType = 2
          }
        } else {
          this.$message.error("获取设备详情失败")
        }
      })
    },
    getDeviceVideo (val) {
      this.loadingCText = "加载中"
      this.loadingC = true
      this.$fetch(api.fire.getDeviceVideo, { deviceId: val, cameraConfigFlag: "0" }).then((res) => {
        setTimeout(() => {
          this.loadingC = false
        }, 1000);
        if (res && res.success) {
          let deviceList = res.returnObj
          if (deviceList.length) {
            if (deviceList.length > 4) {
              this.windowNumber = 9
            }
            deviceList.forEach((el, index) => {
              if (el.thirdCameraId) {
                if (index < this.windowNumber) {
                  this.$nextTick(() => {
                    this.$refs.player.playLiveVideo(el, index + 1)
                  })
                }
              }
            })
          }
        }
      })
    },
    // 获取指令处理结果
    getResult (val) {
      let params = {
        recordCode: val
      }
      this.$fetch(api.fire.queryFirefightingControlReply, params).then((res) => {
        if (this.orderIndex != -1) {
          // 一键操作的逻辑
          if (res && res.success) {
            if (res.returnObj == -1) {
              // 10s继续调用
              setTimeout(() => {
                !this.isGetResult ?
                  this.getResult(val) : ""
              }, 2000)
            } else {
              clearTimeout(this.timeData);
              this.isGetResult = true
              if (this.operationKeyType == 2 && this.orderIndex < this.orderList.length - 1) {
                this.orderIndex += 1
                this.sendStep()
                return false
              }
              this.$message.success("操作成功")
              this.loadingC = false
              this.loadingCB = false
              if (this.operationKeyType == 2) {
                this.activeStep += 1
                this.orderIndex = -1
              }
            }


          } else {
            res.msgContent && this.$message.error(res.msgContent);
          }
          return false
        }
        if (res && res.success) {
          if (res.returnObj == -1) {
            // 10s继续调用
            setTimeout(() => {
              !this.isGetResult ?
                this.getResult(val) : ""
            }, 2000)
          } else {
            this.isGetResult = true
            this.$message.success(Dic.findByValue('SENU096', res.returnObj))
            this.$refs.controlDevice.respondText = this.$refs.controlDevice.respondText + " / " + " 执行结果：【" + Dic.findByValue('SENU096', res.returnObj) + "】"
            this.showPassWord = false
            this.loadingC = false
            this.loadingCB = false
            this.dialogDevice = false

          }
        } else {
          res.msgContent && this.$message.error(res.msgContent);
        }
      })
    },
    controlCodeChange (data) {
      this.controlCode = data
    },
    sendControlCode () {
      this.$refs['controlForm'].validate((vaild) => {
        if (vaild) {
          this.dialogControl = false;
          this.dialogDevice = true
        }
      })
    },
    // 确定发送指令
    sendControl () {
      this.isGetResult = false
      this.$refs.controlDevice.respondText = "执行【" + Dic.findByValue('SENU098', this.deviceKey) + "】"
      this.dialogDevice = false
      this.loadingCText = "等待操作响应"
      if (this.operationKeyType == 1) {
        this.loadingCB = true
      } else {
        this.loadingC = true
      }
      let params = {
        // deviceId: this.detail.parentDeviceId || this.detail.deviceId,		//--主机id
        deviceId: this.switchFj ? this.selectDeviceData.relationDeviceId : this.$route.query.id,		//--传递id
        cmdKey: this.deviceKey,
        needUnLockFlag: this.switchFj ? 0 : 1,
        operateType: this.handleType ? 1 : 2,//1：单键操作，2：一键操作
      }
      if (this.controlType == 2) {
        params.controlCode = this.controlCode
      }
      this.$fetch(api.fire.controlFirefighting, params).then((res) => {
        if (res && res.success) {
          // this.showPassWord = false
          // 开始查询控制回调
          this.getResult(res.returnObj)
          setTimeout(() => {
            if (!this.isGetResult) {
              this.isGetResult = true
              this.$alert('按钮响应超时,请进行复位操作 !', '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                showClose: false,
                callback: action => {
                  this.$refs.controlDevice.respondText = this.$refs.controlDevice.respondText + " / " + " 执行结果：【操作响应失败】"
                  this.showPassWord = false
                  this.loadingC = false
                  this.loadingCB = false
                  this.dialogDevice = false
                }
              });
            }
          }, 10000)
        } else {
          res.msgContent && this.$message.error(res.msgContent);
          this.loadingCB = false
          this.loadingC = false
          this.dialogDevice = false
        }
      })
    },
    controlCallBack (val) {
      this.deviceKey = val
      this.$refs.controlDevice.respondText = ""
      if (this.controlType == 2 && (val == '68' || val == "76")) {
        this.dialogControl = true
      } else {
        this.dialogDevice = true
      }

    },
    cameraData (val, data) {
      // val 摄像机  data 区域
      if (data.length > 0) {
        this.$refs.deviceTree.$refs.appDeviceGroupTree.setCheckedKeys([])
        if (val.length > 0) {
          let idData = val.map(el => {
            return el.id
          })
          this.$refs.deviceTree.$refs.appDeviceGroupTree.setCheckedKeys(idData)
        }
      }
      if (val.length > 0) {
        this.camera = val
      }
    },
    submitDialog () {
      this.$refs.deviceTree.$refs.appDeviceGroupTree.setCheckedKeys([])
      this.dialogVisible = false
      if (this.camera.length > 0) {
        this.camera.forEach((el, index) => {
          // 先获取播放窗口 避免同步加载视频在同一个窗口播放--待优化
          let upIndex = this.$refs.player.getFreeWnd()
          this.$nextTick(() => {
            if (index + upIndex <= this.windowNumber) {
              this.$refs.player.playLiveVideo(el, index + upIndex)
            } else if ((index + upIndex > this.windowNumber) && (index + upIndex <= this.windowNumber * 2)) {
              this.$refs.player.playLiveVideo(el, index + upIndex - this.windowNumber)
            }
          })

        })
      }
    },
    cancelDialog () {
      this.dialogVisible = false
    },
    handleClose () {
      this.dialogVisible = false
    },
    addCamera () {
      this.dialogVisible = true
      // if (this.camera.length > 0) {
      //   let idData = this.camera.map(el => {
      //     return el.id
      //   })
      this.$nextTick(() => {
        this.$refs.deviceTree.$refs.appDeviceGroupTree.setCheckedKeys([])
      })
      // }
    },
    stopAll () {
      this.$refs.player.closeAllVideo();
    },
    changeWindowNumber (number) {
      this.windowNumber = number;
    },
    showScreenSet () {
      this.screenSet = !this.screenSet;
    },
    // 解密
    untie () {
      this.$refs.ruleForm.validate((vaild) => {
        if (vaild) {
          this.passwordLoading = true
          let password = sha256(this.ruleForm.password)
          let params = {
            deviceId: this.detail.subDeviceMark ? this.detail.parentDeviceId : this.detail.deviceId,		//--主机id
            unlockPassword: password
          }
          this.$fetch(api.fire.checkPassword, params).then((res) => {
            if (res && res.success) {
              this.showPassWord = false
              this.$message.success("解锁成功")
            } else {
              res.msgContent && this.$message.error(res.msgContent);
            }
            setTimeout(() => {
              this.passwordLoading = false
            }, 500)
          })
        }
      })

    },
    updateAlarm () {
      let params = {
        alarmId: this.alarmFire[0],
        alarmState: this.alarmFire[1],
        processDesc: "消防键盘已处理确认",
      }
      this.$fetch(api.alarm.updateAlarm, params).then((response) => {
        if (response && response.success) {
          this.goBack()
        }
      })
    },
    goBackT () {
      this.$alert('确定后键盘进入锁屏状态且返回上一页,确定结束所有操作?', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          console.log(action)
          if (action == "confirm") {
            this.updateAlarm()
            // this.goBack()
          }
        }
      });
    },
    goBack () {
      this.stopAll();
      let routeList = JSON.parse(sessionStorage.getItem("fireAfter"))
      this.$router.push({
        name: routeList.nameCopy,
        path: routeList.routeCopy,
        query: { id: this.$route.query.id, idCopy: this.$route.query.idCopy }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.fireManage {
  /deep/.step-row {
    position: absolute;
    width: 46px;
    top: 0px;
    display: none;
    right: -8px;
    border-radius: 34px;
    @include set_theme_color(background-color, main-theme-color);
    i {
      color: #fff;
      cursor: pointer;
      @include set_theme_color(background-color, main-theme-color);
      font-size: 16px;
      margin: 4px;
    }
  }
  padding: 10px;
  .pagefjDevice {
    @include set_theme_color(background-color, menu-tab-bg-color);
    margin: 15px 0;
    padding: 10px;
    font-size: 16px;
    .tabsDevice {
      display: flex;
      color: #fff;
      margin-top: 15px;
      .tabs {
        width: 668px;
        .tabs_content {
          border: 1px solid gray;
          width: 100px;
          padding: 0 5px 3px;
          &_title {
            font-size: 12px;
            height: 30px;
            margin-top: -15px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        /deep/.el-tabs__nav-next,
        /deep/ .el-tabs__nav-prev {
          top: 10px;
          font-size: 20px;
        }
        /deep/ .el-tabs__item {
          height: 85px !important;
          padding: 0 5px !important;
          &:hover {
            .iconClose {
              display: inline;
            }
          }
        }
        .is-top {
          height: 70px !important;
        }
        .is-active {
          .iconClose {
            display: inline;
          }
        }
        .iconClose {
          margin-left: 10px;
          display: none;
          position: absolute;
          top: -8px;
          right: 4px;
          font-size: 17px;
        }
      }
    }
  }

  .el-container {
    height: 100%;
    width: 100vw;
    .el-aside {
      display: flex;
      flex-wrap: wrap;
      .no-data-text {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        @include set_theme_color(color, font-disabled-color);
        .no-data_img {
          margin-bottom: 10px;
        }
      }
      // width: 40% !important;
      width: 700px !important;
      text-align: center;
      line-height: 100%;
      position: relative;
      .leftTop {
        width: 100%;
        .handlePage {
          // height: 65vh;
          margin-top: 40px;
          // display: flex;
          // justify-content: center;
          // align-items: center;
          .handletab {
            width: 100%;
            max-height: 185px;
            flex-flow: wrap;
            display: flex;
            .activeItem {
              .icon {
                display: grid !important;
                color: #fff;
              }
              @include set_theme_color(color, active-border-color);
              @include set_theme_color(border-color, active-border-color);
            }
            .handTabItem {
              cursor: pointer;
              width: 90px;
              border: 1px dashed #fff;
              margin: 8px;
              height: 45px;
              text-align: center;
              line-height: 45px;
              word-break: break-all;
              text-overflow: ellipsis;
              overflow: hidden;
              position: relative;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              &:hover {
                @include set_theme_color(border-color, active-border-color);
                .icon {
                  display: grid;
                  color: #fff;
                }
              }
              .icon {
                @include set_theme_color(background-color, main-theme-color);
                display: flow-root;
                right: -12px;
                position: absolute;
                top: 0px;
                width: 35px;
                display: grid;
                height: 100%;
                display: none;
                padding-top: 5px;
                padding-right: 10px;
                border-radius: 50%;
              }
            }
          }
          .nodata {
            border-bottom: 1px solid gray;
            color: gray;
            text-align: center;
            padding: 6px 0;
          }
          /deep/.el-tabs {
            width: 100%;
            height: 56vh;
            padding: 8px;
            @include set_theme_color(background-color, menu-tab-bg-color);
          }
          /deep/.el-tabs__nav {
            height: 100%;
            display: flex;
            // flex-wrap: wrap;
            // width: 85px;
            .el-tabs__item {
              height: auto;
            }
          }
          .handStep {
            // margin-top: 30px;
            height: 35vh;
            padding: 10px;
            // width: 585px;
            display: inline-flex !important;
            align-items: center;
            display: flex;
            flex-wrap: wrap;
            /deep/ .el-steps {
              display: inline-flex;
            }
            /deep/ .el-step {
              width: 100px;
              margin-bottom: 10px;
              &:hover {
                .step-row {
                  display: inherit !important;
                }
              }
            }
            /deep/ .el-step__head {
              width: 100px;
              position: relative;
            }
            /deep/ .el-step__main {
              width: 100px;
              .is-process {
                color: #fff;
              }
            }
            /deep/ .el-step__description {
              align-items: center;
              display: flex;
              flex-flow: column;
            }
            .el-step__description {
              position: relative;
              height: 40px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
      .leftButton {
        width: 100%;
        .footer {
          @include set_theme_color(background-color, menu-tab-bg-color);
          border-radius: 10px;
          // margin: 0 10px;
          color: #fff;
          padding: 10px;
          .deviceInfo {
            color: #fff;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            // padding: 10px;
            flex-direction: row;
            justify-content: space-between;
            div {
              display: flex;
              width: 47%;
              text-align: left;
              font-size: 14px;
              margin: 4px 0px;
              span {
                display: inline-block;
                width: 50%;
              }
            }
          }
        }
      }
    }
    .password {
      position: absolute;
      width: 100%;
      height: 100vh;
      background: #dcdcdc;
      z-index: 1;
      opacity: 0.3;
      display: block;
    }
    .current {
      display: none;
    }
    .elbut {
      position: absolute;
      z-index: 2;
      width: 50%;
      top: 30%;
      border-radius: 10px;
      padding: 15px;
      @include set_theme_color(background-color, blur-color);
      left: 25%;
    }
    .el-main {
      color: #333;
      text-align: center;
      line-height: 100%;
      padding: 7px 10px;
      margin-right: 100px;
      .wnNum {
        height: 2px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }
  }
}
</style>